import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumGermanBeerDutyReturnCellProductType implements BaseEnumType {
  private static allValues: EnumGermanBeerDutyReturnCellProductType[] = []; // make sure this is top-most
  
  public static none = new EnumGermanBeerDutyReturnCellProductType(0, "None", "enum_german_beer_duty_return_cell_product_type_none");
  public static ownBrewedBeer_E = new EnumGermanBeerDutyReturnCellProductType(1, "OwnBrewedBeer_E", "enum_german_beer_duty_return_cell_product_type_own_brewed_beer__e");
  public static brewedByUsFor3rdParty_L = new EnumGermanBeerDutyReturnCellProductType(2, "BrewedByUsFor3rdParty_L", "enum_german_beer_duty_return_cell_product_type_brewed_by_us_for3rd_party__l");
  public static brewedBy3rdPartyForUs_F = new EnumGermanBeerDutyReturnCellProductType(3, "BrewedBy3rdPartyForUs_F", "enum_german_beer_duty_return_cell_product_type_brewed_by3rd_party_for_us__f");
  public static mixedProduct_M = new EnumGermanBeerDutyReturnCellProductType(4, "MixedProduct_M", "enum_german_beer_duty_return_cell_product_type_mixed_product__m");
  public static ownBeerWithinMixedProduct_A = new EnumGermanBeerDutyReturnCellProductType(5, "OwnBeerWithinMixedProduct_A", "enum_german_beer_duty_return_cell_product_type_own_beer_within_mixed_product__a");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumGermanBeerDutyReturnCellProductType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumGermanBeerDutyReturnCellProductType.none; }
  public isOwnBrewedBeer_E() { return this === EnumGermanBeerDutyReturnCellProductType.ownBrewedBeer_E; }
  public isBrewedByUsFor3rdParty_L() { return this === EnumGermanBeerDutyReturnCellProductType.brewedByUsFor3rdParty_L; }
  public isBrewedBy3rdPartyForUs_F() { return this === EnumGermanBeerDutyReturnCellProductType.brewedBy3rdPartyForUs_F; }
  public isMixedProduct_M() { return this === EnumGermanBeerDutyReturnCellProductType.mixedProduct_M; }
  public isOwnBeerWithinMixedProduct_A() { return this === EnumGermanBeerDutyReturnCellProductType.ownBeerWithinMixedProduct_A; }

  public static getValues(): readonly EnumGermanBeerDutyReturnCellProductType[] {
    return EnumGermanBeerDutyReturnCellProductType.allValues;
  }

  public static getValuesExcept0(): readonly EnumGermanBeerDutyReturnCellProductType[] {
    return EnumGermanBeerDutyReturnCellProductType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumGermanBeerDutyReturnCellProductType {
    const found = EnumGermanBeerDutyReturnCellProductType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumGermanBeerDutyReturnCellProductType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumGermanBeerDutyReturnCellProductType): EnumGermanBeerDutyReturnCellProductType {
    const found = name ? EnumGermanBeerDutyReturnCellProductType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumGermanBeerDutyReturnCellProductType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumGermanBeerDutyReturnCellProductType>): boolean {
    return this.key === other?.key;
  }
}